import type { HttpPost } from '@/shared/infra/http'
import { HttpError, mapServerError } from '@/shared/infra/http'
import type { CheckoutConfirmation } from '@/shared/domain'
import { SessionRequiredError } from '@/shared/domain'
import type { ConfirmCheckout } from '@/modules/auth/use-cases'

export type HttpClientForToken = (accessToken: string) => HttpPost

export class EdgeConfirmCheckoutRepository {
  constructor(private readonly makeHttpClient: HttpClientForToken) {}

  execute: ConfirmCheckout = async (params) => {
    const httpClient = this.makeHttpClient(params.accessToken)
    try {
      return await httpClient.post<
        {
          sessionId: string
          orgType: string
        },
        CheckoutConfirmation
      >({
        url: '/subscriptions/checkout-confirm',
        body: {
          sessionId: params.sessionId,
          orgType: params.orgType,
        },
      })
    } catch (err: unknown) {
      if (err instanceof HttpError && err.status === 401) {
        throw new SessionRequiredError()
      }
      mapServerError(err, {})
    }
  }
}
